import {put, takeLatest, call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";
import {
    UNDELETE_TABLES,
    GET_TABLES_SUCCESS,
    UNDELETE_TABLES_ERROR,
}
    from "../../actions/table";

function* unDeleteTablesSaga(action) {
    try {
        yield call(tableService.UnDeleteTables, action.payload)
        yield put({
            type: GET_TABLES_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_TABLES_ERROR,error: error.data
        });
    }
}


export function* unDeleteTablesSagaWatcher() {
    yield takeLatest(UNDELETE_TABLES, unDeleteTablesSaga);
}